import React, { useEffect, useState, useRef } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import TableViewer from "../../component/tableViewer/TableViewer";

// Function to convert YouTube video links to embedded format
function convertToEmbeddedLink(videoLink) {
  if (videoLink.startsWith("https://www.youtube.com")) {
    const videoId = new URL(videoLink).searchParams.get("v");
    return `https://www.youtube.com/embed/${videoId}`;
  }
  return videoLink;
}

const CoursesForApproval = () => {
  const { token, user_type } = config;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [selectedVideoIndex, setSelectedVideoIndex] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [courses, setCourses] = useState([]);

  //  ------For TableViewer ------
  const coursesRef = useRef([]);
  coursesRef.current = courses;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  const viewMcq = (idNumber, courseNm) => {
    navigate(
      `/viewmcqs/course/${btoa(encodeURIComponent(idNumber))}/${btoa(
        encodeURIComponent(courseNm)
      )}`
    );
  };
  //----------------------------------------------- enable / disable Course -----------------------------------------------
  const enabledisableCourseBtn = (cid, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to approve course?. Are you sure you want to proceed?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, approve it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        enabledisableCourse();
      }
    });

    //If confirm then enable/ disable course
    const enabledisableCourse = async () => {
      try {
        await fetch(`${config.host_url}course/at-status/${cid}/1`, {
          method: "GET",
          headers: {
            token: token,
          },
        })
          .then((response) => response.json())
          .then(function (data) {
            if (data.status === 200) {
              triggerNotification("success", `Course approved successfully`);
              fetchCourses();
            } else if (data.status === 404) {
              // course IDs Not Found
              console.error("Course ID is not found");
              triggerNotification("error", "Course ID is not found");
            } else if (data.status === 401) {
              // Invalid Token
              console.error("Invalid token");
              triggerNotification("error", "Unauthenticated User");
            } else {
              // Internal Server Error or other HTTP errors
              console.error("Internal server error");
              triggerNotification(
                "error",
                "Internal server error, Please try after some time!"
              );
            }
          });
      } catch (error) {
        console.error("Error enabling course", error);
        triggerNotification("error", "Error enabling course");
      }
    };
  };

  //----------------------------------------------- select / view courses table  -------------------------------------------------R
  // Fetch all courses
  const fetchCourses = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}course`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            //  ------For TableViewer ------
            const coursesData = data.data
              .filter((course) => course.status === 0)
              .map((course) => ({
                course: course?.course_name,
                thumbnail: course?.video_thumbnail,
                image: course?.image_link,
                duration: course?.course_duration + " " + course?.duration_unit,
                price: course?.price,
                admin_status: course?.admin_status,
                teacher_status: course?.teacher_status,
                status: course?.status,
                video: course?.video_link,
                idNumber: course?.course_id,
              }));
            setRowData(coursesData);
            //  ------For TableViewer ------

            setCourses(data.data);
            // console.log(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching courses.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCourses();
  }, [token]);

  //----------------------------------------------- select / view single course  -------------------------------------------------R
  const btnShowHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/viewcourse/${encodedId}/cfa`);
  };

  // ------------------------------------------------- Edit / Update course ---------------------------------------------------- U
  const btnEditHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/addcourse/${encodedId}`);
  };

  // ---------------------------------------------------- Delete course ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete course?. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteCourse(deleteId, i);
      }
    });
  };

  //If confirm then delete course
  const handleDeleteCourse = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}course/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification("success", "Course deleted successfully");

            //  ------For TableViewer ------
            const updatedCourses = [...coursesRef.current];
            updatedCourses.splice(i, 1);
            setCourses(updatedCourses);
            const coursesData = updatedCourses.map((course) => ({
              course: course?.course_name,
              thumbnail: course?.video_thumbnail,
              image: course?.image_link,
              duration: course?.course_duration + " " + course?.duration_unit,
              price: course?.price,
              admin_status: course?.admin_status,
              teacher_status: course?.teacher_status,
              status: course?.status,
              video: course?.video_link,
              idNumber: course?.course_id,
            }));
            setRowData(coursesData);
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            // course IDs Not Found
            console.error("Course IDs not found");
            triggerNotification("error", "Course IDs not found");
          } else if (data.status === 401) {
            // Invalid Token
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error deleting course:", error);
      triggerNotification("error", "Error deleting course");
    }
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      headerName: "Courses",
      field: "course",
      width: 380,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          <img
            src={params.data.image}
            alt="Teacher_Image"
            className="rounded h-11 w-11  mr-4"
          />
          <p className="p-0 m-0">{params.data.course}</p>
        </div>
      ),
    },
    // { field: "teacher", filter: true },
    { field: "duration", filter: true, width: 110 },
    { field: "price", filter: true, width: 110 },
    {
      headerName: "Video",
      field: "video",
      width: 80,
      cellRenderer: (params) => (
        <div className="mt-1">
          <div className=" flex  ">
            <td className="align-top  ">
              <div
                onClick={() => {
                  setSelectedVideoIndex(params.data.video);
                  setShowVideoModal(true);
                }}
                className="relative "
              >
                <img
                  src={params.data.thumbnail}
                  alt="Video Thumbnail"
                  className="cursor-pointer rounded object-cover  h-11 w-11"
                />
                <span
                  className="mdi mdi-play mdi-18px mdi-dark  bg-white rounded absolute top-[50%] left-[50%] opacity-90	"
                  style={{ transform: "translate(-50%, -50%)" }}
                ></span>
              </div>
            </td>
          </div>
        </div>
      ),
    },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Course" subpath={["Courses For Approval"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">Courses For Approval</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={btnEditHandle}
                onDelete={btnDeleteHandle}
                onView={btnShowHandle}
                onMcqView={viewMcq}
                onEnable={enabledisableCourseBtn}
              />
            </div>
          )}
        </div>
      </div>

      {/* modal */}
      {showVideoModal && selectedVideoIndex !== null && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-600 bg-opacity-30 z-50">
          <div className="w-11/12 md:w-3/4 lg:w-1/2 xl:w-1/3">
            <div className="flex justify-end">
              <button
                className="text-white"
                onClick={() => {
                  setShowVideoModal(false);
                  setSelectedVideoIndex(null);
                }}
              >
                <span className="mdi mdi-close-box-outline"></span>
              </button>
            </div>
            <video
              src={convertToEmbeddedLink(selectedVideoIndex)}
              type="video/mp4"
              playsInline
              controls
              autoPlay
              className="w-full h-full"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CoursesForApproval;
